import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  type?: "info" | "success" | "warning" | "error" | null;
}

export const ALERT_COLORS = {
  info: "text-[#1397A7]",
  success: "text-green-700",
  warning: "text-orange-600",
  error: "text-[#E54917]",
} as const;

const AlertBox = ({ children, type = "info" }: Props) => {
  const colorClass = ALERT_COLORS[type || "error"];

  return (
    <div
      className={`mb-10 flex items-center justify-center gap-1 border border-current p-4 ${colorClass}`}
    >
      <p className="w-full text-center">{children}</p>
    </div>
  );
};

AlertBox.displayName = "AlertBox";

export { AlertBox };
